<!-- 合计弹窗 -->
<template>
  <div class="check-zone">
    <el-form ref="form" :model="tableData" label-width="100px">
      <el-form-item label="对应仓库" prop="WarehouseId">
        <el-select style="width: 100%" size="small" v-model="searchData.WHId" placeholder="请选择" filterable clearable
          @visible-change="warehouseVisibleChange($event)" @change="warehouseChange">
          <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
            <span style="float: left">{{ item.WarehouseName }}</span>
            <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="汽配编码"><el-select ref="sapcode" size="small" v-model="searchData.GoodsId" filterable clearable remote reserve-keyword placeholder="汽配编码"
          @change="codeChange($event)" :remote-method="query => {
            searchCode(query);
          }
            " v-select-scroll-more="searchCodeLoad" style="width: 100%" popper-class="el-select-style-gray">
          <el-option v-for="optionItem in codeList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.APCode"
            :value="optionItem.EntpTempGoodsId">
            <div class="option-content">
              <div class="project-Name">{{ optionItem.APCode }}</div>
              <div class="project-Name">{{ optionItem.GoodName }}</div>
              <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
            </div>
          </el-option>
          <el-option v-if="loading" disabled value="" style="text-align: center">
            加载中
            <i class="el-icon-loading"></i>
          </el-option>
        </el-select></el-form-item>
      <el-form-item label="当前模式">
        <div style="color: rgb(34, 115, 236);font-size: 16px;">{{ isPur ? '分仓自采模式' : '分仓调拨模式' }}</div>
      </el-form-item>
      <el-form-item label="当前仓库类型" v-if="searchData.WHId">
        <div style="color: rgb(245, 106, 26);font-size: 16px;">{{ isMainSto ? '主仓' : '分仓（ 主仓为：' + mainStoName + ' ）' }}
        </div>
      </el-form-item>
      <el-form-item style="height: 185px;" label="是否满足条件">
        <div :class="isHaveLimitSet ? 'color-green' : 'color-red'">
          <el-tooltip effect="dark" placement="top">
            <div slot="content"> 浮动上限：{{ floatUL }} &nbsp; 浮动下限：{{ floatLL }} </div>
            <span>
              1、分仓上下限是否设置
            </span>
          </el-tooltip>
        </div>
        <div :class="isNewGoods ? 'color-green' : 'color-red'">2、是否新品 </div>
        <div :class="isHaveSto ? 'color-green' : 'color-red'">3、是否未存放过（未在仓库存在过） </div>
        <div :class="isHavePrice ? 'color-green' : 'color-red'">4、是否有最新采购价</div>
        <div :class="isAutoRun ? 'color-green' : 'color-red'" v-if="isUseRemain">
          <el-tooltip effect="dark" placement="top">
            <div slot="content"> 留余数：{{ remain }} &nbsp; 计划数：{{ isPur ? planCount :
              isMainSto ?
                planCount : planTransCount }} &nbsp; 浮动下限：{{ floatLL }} </div>
            <span>
              5、留余加计划是否小于等于浮动下限
            </span>
          </el-tooltip>
        </div>
        <div :class="isAutoRun ? 'color-green' : 'color-red'" v-else>
          <el-tooltip effect="dark" placement="top">
            <div slot="content"> 在仓数：{{ remain }} &nbsp; 计划数：{{ isPur ? planCount :
              isMainSto ?
                planCount : planTransCount }} &nbsp; 浮动下限：{{ floatLL }} </div>
            <span>
              5、在仓数 + 计划 + 待入是否小于等于浮动下限
            </span>
          </el-tooltip>
        </div>
        <div v-if="!isPur" :class="isMainLimitSet ? 'color-green' : 'color-red'"><el-tooltip effect="dark" placement="top">
            <div slot="content"> 浮动上限：{{ mainStoFloatUL }} &nbsp; 浮动下限：{{ mainStoFloatLL }} </div>
            <span>
              6、主仓上下限是否设置
            </span>
          </el-tooltip> </div>
      </el-form-item>
      <el-form-item label="计算模式">
        <div style="color: rgb(34, 115, 236);font-size: 16px;">
          <el-tooltip effect="dark" placement="bottom">
            <div slot="content" v-if="isUseRemain"> 留余（ {{ remain }} ） = 实际在仓数（ {{ invenCount }} ） - 待出数（ {{ needOut }}
              ）{{
                isAddWaitOut ? ' - 退货待出（ ' + pReturnOut + ' ）' : '' }}{{
    isAddWaitIn ? ' + 待入数（ ' + needIn + ' ） + 退货待入数（ ' + sReturnIn + ' ）' : '' }}</div>
            <div slot="content" v-else> 实际在仓数（ {{ invenCount }} ） + 待入数（{{ needIn }}） </div>
            <span>
              <i class="el-icon-warning-outline" style="color: orange"></i>
              {{ isUseRemain ? '留余数计算' : '在仓数计算' }}
            </span>
          </el-tooltip>
        </div>
      </el-form-item>
      <el-form-item label="留余数" v-if="isUseRemain">{{ remain }}</el-form-item>
      <el-form-item label="在仓数" v-else>
        {{ remain }}</el-form-item>
      <el-form-item label="新品区间"><el-tooltip effect="dark" placement="bottom">
          <div slot="content"> 在时间区间内创建的商品 </div>
          <span>
            <i class="el-icon-warning-outline" style="color: orange"></i>
            {{ goodsCreateDays }} 天
          </span>
        </el-tooltip></el-form-item>
      <el-form-item label="采购区间"><el-tooltip effect="dark" placement="bottom">
          <div slot="content"> 获取采购区间天数内供应商的最低价 </div>
          <span>
            <i class="el-icon-warning-outline" style="color: orange"></i>
            {{ purDays }} 天
          </span>
        </el-tooltip></el-form-item>
      <el-form-item label="采购最低价" :class="isHavePrice ? 'color-green' : 'color-red'"><i v-if="isHavePrice" class="el-icon-warning-outline color-green"
          @click="() => { showPurHis = true }">{{
            purPrice }}</i> <i v-else> {{
    purPrice }}</i></el-form-item>
      <el-form-item :label="isPur ? '采购计划数' : isMainSto ? '采购计划数' : '调拨计划数'">
        <i class="el-icon-warning-outline color-green" @click="showPlanFunc"> {{ isPur ? planCount :
          isMainSto ?
            planCount : planTransCount }}</i>
      </el-form-item>
      <el-form-item label="补货数">{{ needCount }}</el-form-item>
    </el-form>
    <el-dialog append-to-body :close-on-click-modal="false" title="采购数据" @close="() => { showPurHis = false }" :visible.sync="showPurHis" width="1000px">
      <div class="dialog-content" v-if="showPurHis">
        <PurHisForAutoPur :goodsId="searchData.GoodsId" :whId="searchData.WHId" :purDays="purDays" :apCode="apCode">
        </PurHisForAutoPur>
      </div>
    </el-dialog>
    <el-dialog append-to-body :close-on-click-modal="false" title="计划采购数据" @close="() => { showPlanPur = false }" :visible.sync="showPlanPur" width="1000px">
      <div class="dialog-content" v-if="showPlanPur">
        <PlanPurForAutoPur :goodsId="searchData.GoodsId" :whId="searchData.WHId" :apCode="apCode">
        </PlanPurForAutoPur>
      </div>
    </el-dialog>
    <el-dialog append-to-body :close-on-click-modal="false" title="计划调拨数据" @close="() => { showPlanTrans = false }" :visible.sync="showPlanTrans" width="1000px">
      <div class="dialog-content" v-if="showPlanTrans">
        <PlanTransForAutoPur :goodsId="searchData.GoodsId" :whId="searchData.WHId" :apCode="apCode">
        </PlanTransForAutoPur>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PurHisForAutoPur from '@/components/business/purManage/purHisForAutoPur';
import PlanPurForAutoPur from '@/components/business/purManage/planPurForAutoPur';
import PlanTransForAutoPur from '@/components/business/purManage/planTransForAutoPur';
export default {
  name: '',
  components: {
    PurHisForAutoPur,
    PlanPurForAutoPur,
    PlanTransForAutoPur
  },
  data() {
    return {
      loading: false,
      showPurHis: false,
      showPlanPur: false,
      showPlanTrans: false,
      apCode: '',
      codeList: [],
      warehouseList: [],
      tableData: {},
      // 用于汽配编码列表，分页搜索功能
      codeForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: '',
      },
      isPur: false,
      isAddWaitOut: false,
      isAddWaitIn: false,
      isUseRemain: false,
      searchData: {
        GoodsId: '',
        WHId: ''
      },
      planCount: 0,
      floatLL: 0,
      floatUL: 0,
      isHaveLimitSet: false,
      isHaveOrder: false,
      isHaveSto: false,
      isNewGoods: false,
      isMainLimitSet: false,
      mainStoFloatLL: 0,
      mainStoFloatUL: 0,
      needCount: 0,
      goodsCreateDays: 0,
      purDays: 0,
      saleCount: 0,
      purPrice: 0,
      remain: 0,
      isHavePrice: 0,
      isAutoRun: false,
      invenCount: 0,
      needOut: 0,
      sReturnIn: 0,
      needIn: 0,
      pReturnOut: 0,
      planTransCount: 0,
      isMainSto: 0,
      mainStoName: 0
    };
  },
  mounted() {
    let that = this;
    that.getConfigByCodes();
  },
  methods: {
    getConfigByCodes() {
      return new Promise(resolve => {
        let codes = [
          'xpdbsjfw',
          'fczdcjdbdhcgd',
          'qxnmrgysmc',
          'lybsdr',
          'lybsdc',
          'zjdcgjlysjs'
        ];
        this.$util.getSysConfigs(codes).then(data => {
          if (data) {
            for (let i = 0; i < data.length; i++) {
              let code = data[i].Code;
              let result = data[i].Result;
              let rValue = data[i].RValue;
              switch (code) {
                case 'xpdbsjfw': //补货按照区间天数的销售量
                  this.goodsCreateDays = rValue;
                  break;
                case 'fczdcjdbdhcgd': // 采购还是调拨模式
                  this.isPur = result;
                  break;
                case 'qxnmrgysmc': // 采购价天数
                  this.purDays = rValue;
                  break;
                case 'lybsdr': // 获取留余的计算方式：不计待入
                  this.isAddWaitIn = !result;
                  break;
                case 'lybsdc': // 获取留余的计算方式：不计采购退货待出
                  this.isAddWaitOut = !result;
                  break;
                case 'zjdcgjlysjs': // 使用留余还是在仓数进行计算
                  this.isUseRemain = !result;
                  break;
              }
            }
          }
          resolve();
        });
      });
    },
    searchCode(key, item, index) {
      if (![undefined].includes(key)) {
        this.codeForm.Page = 1;
        this.codeForm.stopLoad = false;
        this.codeForm.key = key;
        this.codeForm.rowIndex = index;
        this.codeList = [];
      }
      if (item) {
        item.APCode = key;
      }
      if (this.codeForm.stopLoad) return;
      this.loading = true;
      this.$util
        .axiosGet({
          url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
          data: {
            APCode: this.codeForm.key,
            Page: this.codeForm.Page,
            Limit: this.codeForm.Limit,
          },
          hideLoading: true,
        })
        .then((res) => {
          let that = this;
          that.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
          that.codeList = that.$util.uniqueArr(that.codeList, res.data);
          that.loading = false;
        });
    },
    // 汽配编码列表，加载更多
    searchCodeLoad() {
      if (!this.loading) {
        this.codeForm.Page += 1;
        this.searchCode();
      }
    },
    codeChange(value) {
      if (!this.searchData.WHId) {
        this.$util.warningMsg('请选择对应仓库');
        return;
      }
      if (value) {
        this.getCheckData();
      }
    },
    getCheckData() {
      let that = this;
      that.$util
        .axiosGet({
          url: '/api/EntpPurchaseOrder/GetAutoTransCheckData',
          data: that.searchData,
        })
        .then((res) => {
          let data = res.data;
          if (!data) {
            return;
          }
          that.planCount = data.PlanCount;
          that.floatLL = data.FloatLL;
          that.floatUL = data.FloatUL;
          that.isHaveLimitSet = data.IsHaveLimitSet;
          that.isHaveOrder = data.IsHaveOrder;
          that.isHaveSto = data.IsHaveSto;
          that.isNewGoods = data.IsNewGoods;
          that.isMainLimitSet = data.IsMainLimitSet;
          that.mainStoFloatLL = data.MainStoFloatLL;
          that.mainStoFloatUL = data.MainStoFloatUL;
          that.needCount = data.NeedCount;
          that.goodsCreateDays = data.GoodsCreateDays;
          that.purDays = data.PurDays;
          that.saleCount = data.SaleCount;
          that.purPrice = data.LastPrice;
          that.remain = data.Remain;
          that.isHavePrice = data.IsHavePrice;
          that.isAutoRun = data.IsAutoRun;
          that.invenCount = data.InvenCount;
          that.needOut = data.NeedOut;
          that.sReturnIn = data.SReturnIn;
          that.needIn = data.NeedIn;
          that.pReturnOut = data.PReturnOut;
          that.planTransCount = data.PlanTransCount;
          that.isMainSto = data.IsMainSto;
          that.mainStoName = data.MainStoName;
          this.apCode = data.APCode;
        })
        .catch(() => { });
    },
    warehouseVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.warehouseList.length <= 1) that.getWarehouse();
      }
    },
    // 获取仓库列表
    getWarehouse() {
      this.$util.getWarehouseNotAuth(1).then(data => {
        this.warehouseList = data;
      });
    },
    warehouseChange(value) {
      if (!this.searchData.GoodsId) {
        this.$util.warningMsg('请选择对应商品');
        return;
      }
      if (value) {
        this.getCheckData();
      }
    },
    showPlanFunc() {
      let that = this;
      let showPur = false;
      if (that.isPur)
        showPur = true;
      else
        if (that.isMainSto) showPur = true;

      if (showPur)
        that.showPlanPur = true;
      else
        that.showPlanTrans = true;


    }
  },
};
</script>
<style lang="less" scoped>
.option-content {
  display: flex;
  line-height: 30px;

  .project-Name {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 12px;
  }

  .project-iven {
    width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.color-red {
  color: rgb(245, 77, 77);
}

.color-green {
  color: rgb(43, 211, 113);
}
</style>
<style lang="less">
.check-zone {
  .el-form-item {
    margin-bottom: 2px;
    line-height: 32px;
    height: 32px;
  }

  .el-form-item__label {
    line-height: 32px;
    height: 32px;
  }

  .el-form-item__content {
    line-height: 32px !important;
    height: 32px;
    top: -1px;
  }
}
</style>